import { EnumOptInMethodTypes } from 'entities/Compliance/api/types/complianceType'

export enum TollFreeRoutes {
  root = 'toll-free',
  view = 'view',
  steps = 'steps',
  addNumber = 'add-number',
}

export enum TollFreeRoutesSteps {
  numbers = 'numbers',
  businessInfo = 'business-info',
  contactInfo = 'contact-info',
  useCase = 'use-case',
  optInMethod = 'opt-in-method',
  optInOnlineFormContent = 'opt-in-online-form-consent',
  optInPaperFormContent = 'opt-in-paper-form-consent',
  optInViaTextContent = 'opt-in-via-text-consent',
  optInQrCodeContent = 'opt-in-qr-code-consent',
  forbiddenMessageTopics = 'forbidden-message-topics',
  addTollFreeNumber = 'add-toll-free-number',
}

export const stepsToTypeIdMap = {
  [TollFreeRoutesSteps.optInOnlineFormContent]: 10,
  [TollFreeRoutesSteps.optInPaperFormContent]: 7,
  [TollFreeRoutesSteps.optInViaTextContent]: 9,
  [TollFreeRoutesSteps.optInQrCodeContent]: 8,
}

export const idToTypeMap = {
  10: TollFreeRoutesSteps.optInOnlineFormContent,
  7: TollFreeRoutesSteps.optInPaperFormContent,
  9: TollFreeRoutesSteps.optInViaTextContent,
  8: TollFreeRoutesSteps.optInQrCodeContent,
}

export const idToKeyMap: Record<number, EnumOptInMethodTypes> = {
  10: EnumOptInMethodTypes.onlineForm,
  7: EnumOptInMethodTypes.paperForm,
  9: EnumOptInMethodTypes.text,
  8: EnumOptInMethodTypes.qrCode,
}

export type StepsToTypeIdMap = {
  [key in
    | TollFreeRoutesSteps.optInOnlineFormContent
    | TollFreeRoutesSteps.optInPaperFormContent
    | TollFreeRoutesSteps.optInViaTextContent
    | TollFreeRoutesSteps.optInQrCodeContent]: number
}

export type IdToTypeMap = {
  [key in 7 | 8 | 9 | 10]:
    | TollFreeRoutesSteps.optInOnlineFormContent
    | TollFreeRoutesSteps.optInPaperFormContent
    | TollFreeRoutesSteps.optInViaTextContent
    | TollFreeRoutesSteps.optInQrCodeContent
}

export const IOptInMethodsMap: Partial<Record<TollFreeRoutesSteps, EnumOptInMethodTypes>> = {
  [TollFreeRoutesSteps.optInOnlineFormContent]: EnumOptInMethodTypes.onlineForm,
  [TollFreeRoutesSteps.optInPaperFormContent]: EnumOptInMethodTypes.paperForm,
  [TollFreeRoutesSteps.optInViaTextContent]: EnumOptInMethodTypes.text,
  [TollFreeRoutesSteps.optInQrCodeContent]: EnumOptInMethodTypes.qrCode,
}

export const IOptInYTypeMap: Partial<Record<EnumOptInMethodTypes, TollFreeRoutesSteps>> = {
  [EnumOptInMethodTypes.onlineForm]: TollFreeRoutesSteps.optInOnlineFormContent,
  [EnumOptInMethodTypes.paperForm]: TollFreeRoutesSteps.optInPaperFormContent,
  [EnumOptInMethodTypes.text]: TollFreeRoutesSteps.optInViaTextContent,
  [EnumOptInMethodTypes.qrCode]: TollFreeRoutesSteps.optInQrCodeContent,
}

export const optInTollFreeMethodTypes = {
  [EnumOptInMethodTypes.onlineForm]: 'WEB_FORM',
  [EnumOptInMethodTypes.paperForm]: 'PAPER_FORM',
  [EnumOptInMethodTypes.text]: 'VIA_TEXT',
  [EnumOptInMethodTypes.qrCode]: 'MOBILE_QR_CODE',
}

export const optInTollFreeMethodMap = {
  WEB_FORM: EnumOptInMethodTypes.onlineForm,
  PAPER_FORM: EnumOptInMethodTypes.paperForm,
  VIA_TEXT: EnumOptInMethodTypes.text,
  MOBILE_QR_CODE: EnumOptInMethodTypes.qrCode,
}

export enum TollFreeAddNumberRoutesSteps {
  Numbers = 'numbers',

  ChooseNumber = 'choose-number',
  AssignNumber = 'assign-number',
  Payment = 'payment',
}
